<footer class="site-footer" [style.--primary]="configService.settings.color">
  <div class="footer-grid">
    <div class="footer-brand-col">
      <a class="brand" [href]="homePath" [attr.aria-label]="configService.settings.name">
        <img [src]="configService.settings.logo.imageMedium" [srcset]="
          configService.settings.logo.imageSmall + ' 200w, ' +
          configService.settings.logo.imageMedium + ' 400w, ' +
          configService.settings.logo.imageLarge + ' 800w'
        " [alt]="configService.settings.name" />
      </a>
      <div class="socials" [attr.aria-label]="'footer.social'|traduccion">
        @if (landingPageData.currentConfig()?.rrss?.facebook) {
          <a [href]="landingPageData.currentConfig()!.rrss.facebook" target="_blank" rel="noopener noreferrer" aria-label="Facebook">◎</a>
        }
        @if (landingPageData.currentConfig()?.rrss?.instagram) {
          <a [href]="landingPageData.currentConfig()!.rrss.instagram" target="_blank" rel="noopener noreferrer" aria-label="Instagram">◉</a>
        }
        @if (landingPageData.currentConfig()?.rrss?.tiktok) {
          <a [href]="landingPageData.currentConfig()!.rrss.tiktok" target="_blank" rel="noopener noreferrer" aria-label="TikTok">♪</a>
        }
      </div>
      <p class="copyright">© {{ now.getFullYear() }} {{ configService.settings.name }}. {{'footer.rights'|traduccion}}</p>
    </div>

    <div class="footer-column">
      <h3>{{'footer.links'|traduccion}}</h3>
      <a [href]="landingEnabled ? language.path() + '#ubicaciones' : homePath">{{'nav.locations'|traduccion}}</a>
      @if (landingEnabled) {
        <a [href]="language.path() + '#como-funciona'">{{'nav.howItWorks'|traduccion}}</a>
        <a [href]="language.path() + '#tamanos'">{{'nav.sizes'|traduccion}}</a>
        @if (configService.settings.visibilityControl?.faqEnabled) {
          <a [href]="language.path() + '#faq'">{{'nav.faq'|traduccion}}</a>
        }
        <a [href]="language.path() + '#contacto'">{{'nav.contact'|traduccion}}</a>
      }
    </div>

    <div class="footer-column">
      <h3>{{'nav.contact'|traduccion}}</h3>
      <a [href]="'mailto:' + configService.settings.email"><span class="footer-icon">✉</span>{{ configService.settings.email }}</a>
      <a [href]="'tel:' + configService.settings.phone"><span class="footer-icon">⌕</span>{{ configService.settings.phone }}</a>
      <p><span class="footer-icon">●</span>{{'footer.address'|traduccion}}</p>
    </div>

    <div class="footer-column legal-links">
      <h3>{{'footer.legal'|traduccion}}</h3>
      @if (configService.settings.legalPages?.privacyPolicyEnabled) {
        <a [routerLink]="language.path('privacy-policy')">{{ 'legal.privacyPolicy' | traduccion }}</a>
      }
      @if (configService.settings.legalPages?.termsServiceEnabled) {
        <a [routerLink]="language.path('terms-service')">{{ 'legal.termsService' | traduccion }}</a>
      }
      @if (configService.settings.legalPages?.cookiePolicyEnabled) {
        <a [routerLink]="language.path('cookie-policy')">{{ 'legal.cookiePolicy' | traduccion }}</a>
      }
      @if (configService.settings.legalPages?.legalNoticeEnabled) {
        <a [routerLink]="language.path('legal-notice')">{{ 'legal.legalNotice' | traduccion }}</a>
      }
    </div>
  </div>
</footer>
